var _title, _symbol, _title2, _title3, _title4, _title5, _symbol2, _symbol3, _title6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 33 32"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Search")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M12.139 0c3.152 0 6.176 1.252 8.404 3.481s3.481 5.252 3.481 8.404c0 2.944-1.079 5.65-2.853 7.735l0.494 0.494h1.445l9.143 9.143-2.743 2.743-9.143-9.143v-1.445l-0.494-0.494c-2.157 1.841-4.899 2.852-7.735 2.853-3.152 0-6.175-1.252-8.404-3.481s-3.481-5.252-3.481-8.404c0-3.152 1.252-6.175 3.481-8.404s5.252-3.481 8.404-3.481zM12.139 3.657c-4.571 0-8.229 3.657-8.229 8.229s3.657 8.229 8.229 8.229c4.571 0 8.229-3.657 8.229-8.229s-3.657-8.229-8.229-8.229z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 57 32"
  }, /*#__PURE__*/React.createElement("title", null, "Menu"), /*#__PURE__*/React.createElement("path", {
    d: "M31.852 26.627c1.955 0 3.539 1.192 3.539 2.663s-1.585 2.663-3.539 2.663h-7.078c-1.955 0-3.539-1.192-3.539-2.663s1.585-2.663 3.539-2.663h7.078zM42.469 13.313c1.955 0 3.539 1.192 3.539 2.663s-1.584 2.663-3.539 2.663h-28.313c-1.955 0-3.539-1.192-3.539-2.663s1.585-2.663 3.539-2.663h28.313zM53.086 0c1.955 0 3.539 1.192 3.539 2.663s-1.585 2.663-3.539 2.663h-49.547c-1.955 0-3.539-1.192-3.539-2.663s1.585-2.663 3.539-2.663h49.547z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 19 32"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Arrow")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M0 3.733l3.676-3.733 15.753 16-15.753 16-3.676-3.733 12.077-12.267-12.077-12.267z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-person",
    viewBox: "0 0 32 32"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Person")), /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    style: {
      fill: "var(--color1, #696969)"
    },
    d: "M16 16c4.418 0 8-3.582 8-8s-3.582-8-8-8c-4.418 0-8 3.582-8 8s3.582 8 8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    style: {
      fill: "var(--color1, #696969)"
    },
    d: "M19.2 19.2h-6.4c-3.395 0-6.651 1.349-9.051 3.749s-3.749 5.656-3.749 9.051h32c0-3.395-1.349-6.651-3.749-9.051s-5.656-3.749-9.051-3.749z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-time",
    viewBox: "0 0 32 32"
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Time")), /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    style: {
      fill: "var(--color1, #696969)"
    },
    d: "M30.761 16.636c-0.779-0.101-1.523 0.438-1.625 1.213-0.406 2.83-1.693 5.391-3.724 7.412-5.145 5.121-13.506 5.121-18.651 0s-5.145-13.444 0-18.565 13.506-5.121 18.651 0l0.372 0.371h-2.166c-0.812 0-1.456 0.64-1.456 1.449s0.643 1.449 1.456 1.449h5.653c0.812 0 1.455-0.64 1.455-1.449v-5.627c0-0.809-0.643-1.449-1.455-1.449s-1.455 0.64-1.455 1.449v2.156l-0.372-0.371c-6.262-6.233-16.485-6.233-22.747 0s-6.262 16.408 0 22.642c3.148 3.134 7.244 4.683 11.373 4.683s8.225-1.55 11.373-4.683c2.471-2.46 4.062-5.593 4.536-9.030 0.135-0.809-0.406-1.516-1.218-1.651z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696969",
    style: {
      fill: "var(--color1, #696969)"
    },
    d: "M21.825 17.006l-4.299-1.954-0.068-6.907c0-0.775-0.643-1.415-1.456-1.415s-1.422 0.64-1.422 1.449l0.034 7.817c0 0.573 0.338 1.078 0.846 1.28l5.145 2.325c0.203 0.101 0.406 0.135 0.609 0.135 0.541 0 1.083-0.303 1.32-0.843 0.338-0.708 0-1.55-0.711-1.887z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-success",
    viewBox: "0 0 32 32"
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "Success")), /*#__PURE__*/React.createElement("path", {
    fill: "#02d70a",
    style: {
      fill: "var(--color1, #02d70a)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.781 20.346l-4.836-4.681-1.612 1.56 6.449 6.241 13.818-13.373-1.612-1.56-12.206 11.813z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("title", null, "Close"), /*#__PURE__*/React.createElement("path", {
    d: "M32 3.2l-3.2-3.2-12.8 12.8-12.8-12.8-3.2 3.2 12.8 12.8-12.8 12.8 3.2 3.2 12.8-12.8 12.8 12.8 3.2-3.2-12.8-12.8 12.8-12.8z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-right-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("title", null, "Arrow"), /*#__PURE__*/React.createElement("path", {
    d: "M16 0l-2.8 2.8 11.2 11.2h-24.4v4h24.4l-11.2 11.2 2.8 2.8 16-16-16-16z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 32 32"
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Cross")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M28.632 12.632c0 6.976-5.655 12.632-12.632 12.632s-12.632-5.655-12.632-12.632c0-6.976 5.655-12.632 12.632-12.632s12.632 5.655 12.632 12.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090620",
    style: {
      fill: "var(--color2, #090620)"
    },
    d: "M21.895 7.916l-1.179-1.179-4.716 4.716-4.716-4.716-1.179 1.179 4.716 4.716-4.716 4.716 1.179 1.179 4.716-4.716 4.716 4.716 1.179-1.179-4.716-4.716 4.716-4.716z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.96cb2aaefc7c2aec28ebdcabb50bb82e.svg";
export { ForwardRef as ReactComponent };